import {useCallback} from 'react';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';

interface UseSystemMessageLinkProps {
    message: TSystemMessage;
    close?: () => void;
    showVideos: {
        open: () => void;
        close: () => void;
    };
    showEvents: {
        close: () => void;
    };
}

function useSystemMessageLink({message, close, showVideos, showEvents}: UseSystemMessageLinkProps) {
    const handleLinkClick = useCallback((e: React.MouseEvent) => {
        if(message.link?.includes('/support')) {
            e.preventDefault();
            showVideos.open();
            showEvents.close();
        }
        close?.();
    }, [message.link, close, showVideos, showEvents]);

    return {handleLinkClick};
}

export default useSystemMessageLink;
